// @givmo/app-charity — what the email screens' director arrival shares (CBG-SEC2 SEC2-WEB; contract
// §4.3, mockup 2).
//
// The sign-in form, the create form and the email confirmation each take an `arrival` prop. Their
// director arrival renders in Board's director shell with the form in a card, as the approved frames
// draw it (`m2-email-sign-in`, `m2-email-create`, `m2-email-confirm`); these are the pieces the three
// cards have in common — the footer under the form and its two link treatments.

import type { ReactNode } from 'react';

/** The house text link, at the footer's size (`auth-door.tsx`, `sign-in-screen.tsx`). */
export const DIRECTOR_AUTH_LINK =
  'font-w600 text-brand-700 outline-none transition-colors hover:text-brand-800 focus-visible:underline motion-reduce:transition-none';

/** The quieter way back, under the main link. */
export const DIRECTOR_AUTH_QUIET_LINK =
  'font-sans text-s13 font-w400 tracking-givmo text-text-secondary outline-none transition-colors hover:text-text-strong focus-visible:underline motion-reduce:transition-none';

/**
 * What the two forms carry across to each other: where the director was going, and Board's
 * `another_account` arrival, so a lock notice on the sign-in form still offers no organization door
 * however the director got there (cut 1007e's fold, Board's B-F4 and R1). Both director email routes
 * keep the two (`router/routes.tsx`, `parseDirectorEmailSearch`).
 */
export function directorEmailSearch(
  redirect: string | undefined,
  arrival: 'another_account' | undefined,
): { redirect?: string; arrival?: 'another_account' } {
  return {
    ...(redirect ? { redirect } : {}),
    ...(arrival === 'another_account' ? { arrival } : {}),
  };
}

/** The card's footer: a rule, then the ways over to the other form and back, centred. */
export function DirectorAuthFooter({ children }: { children: ReactNode }) {
  return (
    <div className="flex flex-col items-center gap-8 border-t border-border-subtle pt-20 text-center font-sans text-s14 font-w400 tracking-givmo text-text-secondary">
      {children}
    </div>
  );
}
